import React from 'react';
import { arrayOf, object, string, shape } from 'prop-types';
import classnames from 'classnames';
import BundleItemComponent from 'components/BundleItemComponent';
import BundleSponsor from 'components/BundleSponsor';
import Ad from 'components/Ad';
import EmailSignup from 'components/EmailSignup';
import Figure from 'components/Figure';
import Html from 'components/Html';
import PersonProfile from 'components/PersonProfile';
import InlineSearchForm from 'components/InlineSearchForm';
import ThirdPartyEmbed from 'components/ThirdPartyEmbed';
import Video from 'components/Video';
import {
  DEFAULT_PLACEMENT,
  DEFAULT_IMAGE_SOURCE_SIZES,
  getBundleType
} from './helper';
import styles from './styles.js';

const BUNDLE_COMPONENTS = {
  ad: Ad, // Spreads
  emailSignup: EmailSignup, // Interrupters
  html: Html, // Interrupters
  image: Figure, // Interrupters
  profile: PersonProfile, // Author pages
  search: InlineSearchForm, // Interrupters
  thirdParty: ThirdPartyEmbed, // Homemade pages
  video: Video // Interrupters
};

/* A basic bundle - it simply renders a collection of items inside a wrapper.
 * A typical use case is rendering an ad, video, or interrupter bundle that
 * does not require the complexity of a spread.
 */
function ItemBundle(props) {
  const { items, variant } = props;
  const { color, description, sponsor, title } = props.data;

  const bundleType = items.length > 0 && getBundleType(items);

  const itemBundleClasses = classnames('ItemBundle', {
    [`ItemBundle--${variant}`]: variant,
    [`ItemBundle--${bundleType}`]: bundleType,
    [`theme--${color}`]: color
  });

  return (
    <div className={itemBundleClasses}>
      {title && <div className="ItemBundle__heading">{title}</div>}
      {sponsor && <BundleSponsor cssHook="ItemBundle" {...sponsor} />}
      {description && (
        <div className="ItemBundle__description">{description}</div>
      )}
      {items.map(item => (
        <BundleItemComponent
          key={item.id}
          item={item}
          customPropsMapper={(data, type) => {
            if (type === 'image') {
              return {
                ...data,
                placement: DEFAULT_PLACEMENT,
                sourceSizes: DEFAULT_IMAGE_SOURCE_SIZES,
                maxWidth: variant === 'banner' ? 2400 : undefined
              };
            }
            return data;
          }}
          components={BUNDLE_COMPONENTS}
        />
      ))}
      <style jsx>{styles}</style>
    </div>
  );
}

ItemBundle.propTypes = {
  data: shape({
    color: string,
    sponsor: shape({
      imageUrl: string,
      messaging: string,
      name: string
    }),
    title: string,
    description: string
  }),
  variant: string,
  items: arrayOf(
    shape({
      id: string.isRequired,
      type: string.isRequired,
      data: object
    })
  )
};

ItemBundle.defaultProps = {
  data: {},
  variant: undefined,
  items: []
};
export default ItemBundle;
